import { render, staticRenderFns } from "./pagar-emolumentos.vue?vue&type=template&id=28340dbc&"
import script from "./pagar-emolumentos.vue?vue&type=script&lang=js&"
export * from "./pagar-emolumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports